// Auto generated file, do not manually modify!
// com.hotpads.renterinfo.web.api.web.v1.renterprofile.enums.RenterProfileStandalonePageTotalPeopleInHousehold

export enum RenterProfileStandalonePageTotalPeopleInHousehold {
  FIVE_PLUS = '5_PLUS',
  FOUR = '4',
  ONE = '1',
  THREE = '3',
  TWO = '2',
}

export const RenterProfileStandalonePageTotalPeopleInHousehold_values = [
  RenterProfileStandalonePageTotalPeopleInHousehold.FIVE_PLUS,
  RenterProfileStandalonePageTotalPeopleInHousehold.FOUR,
  RenterProfileStandalonePageTotalPeopleInHousehold.ONE,
  RenterProfileStandalonePageTotalPeopleInHousehold.THREE,
  RenterProfileStandalonePageTotalPeopleInHousehold.TWO,
] as const;
